import NoPermission from '@/src/components/NoPermission';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import qs from 'query-string';
import React from 'react';
import {
  //useDispatch,
  useSelector,
} from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Form, Spin } from 'src/components/Antd';
import _RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { getCurrentSalesChannel } from 'src/constrains/SalesChannelHOC/slice';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { ECondition } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import {
  EType,
  EApplyTo as OrderEligibleApplyTo,
  EProductsMatchRule as OrderEligibleMatchRule,
} from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/OrderEligibleCondition/EligibleCard';
import { EProductType } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsApplyToRadioAndTable';
import { EApplyTo } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsCollectionRadioTable';
import { handleOnCheckTime } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/tools';
import { maxPerCustomerCheckbox } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/UsageLimitation';
import {
  activateDiscount,
  archiveDiscount,
  draftDiscount,
  getDiscountDetail,
} from 'src/request/salesChannel/discounts';
import { saveDirectDiscount } from 'src/request/salesChannel/discounts/directDiscount';
import { NEW } from 'src/tools/constant';
import { onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet, handleOnGetCurrentSCTimezoneUTC } from 'src/tools/tools';
import { EShipping, EnumStatus } from 'src/types/common/discount';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { modal } from 'src/utils/Modal';
import { discountPermissions } from '../../Components/hooks/permissions';
import Attributes from './Attribute';
import BasicInfo from './BasicInfo';
import Buy1Get1Free, {
  CumulativeType,
  DiscountValueType,
} from './Buy1Get1Free';
import CustomerEligibleCondition from './CustomerEligible';
import DeliveryMethod from './DeliveryMethod';
import Destination, { EDestinationType } from './Destination';
import Method, { EMethod } from './DiscountMethod';
import FixedReductionAmount from './FixedReductionAmount';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import OrderEligibleSection from './OrderEligible';
import PercentageOff from './PercentageOff';
import ShippingDiscountValue from './ShippingDiscountValue';
import Summary from './Summary';
import Usage from './UsageLimitation';
import { switchUuidHooks } from './hooks';

//defaultName
const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};
const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};

const nameDuplicate = 120009;
const Item = Form.Item;
const formName = 'DirectDiscount';
const DirectDiscount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();
  const m: any = useLocation();
  const { defaultName } = qs.parse(m.search);
  const salesChannel = useSelector(getCurrentSalesChannel());
  const currency = get(salesChannel, 'currency');
  const { isPrimary } = props;
  const currentLanguage = useQueryLanguageListContentEditor();
  const history = useHistory();
  const { uuid, discountUuid }: any = useParams();
  const { canViewDetail, canEdit, canDelete } = discountPermissions(uuid);
  const defaultState = {
    status: EnumStatus.Draft,
    salesChannelUuid: uuid,
    uuid: null,
    discountMethod: {
      discountType: EMethod.Percentage,
      discountValue: DiscountValueType.Free,
      discountItemScope: EApplyTo.All,
      destinationType: EDestinationType.All,
      cumulativeType: CumulativeType.ConditionCumulative,
      shippingDiscountType: EShipping.Free,
      deliveryMethod: EApplyTo.All,
    },
    stackingPrivilegeEnabled: false,
    customerCondition: { conditionType: ECondition.Everyone },
    conditions: {
      enabled: false,
      conditions: [
        {
          basedOn: EType.Value,
          applyTo: OrderEligibleApplyTo.All,
          matchRule: OrderEligibleMatchRule.Any,
          collections: [],
          products: [],
        },
      ],
    },
    applyTo: { conditionType: EProductType.All },
    name: defaultName || '',
  };

  const isNew = discountUuid === NEW;
  const [form] = Form.useForm();
  const [activeTime, setActiveTime] = React.useState({
    beginDate: '',
    beginTime: '',
    endDate: '',
    endTime: '',
  });
  const [activeTimeError, setActiveTimeError] = React.useState(false);
  const [hasModified, setHasModified] = React.useState(false);
  const [discountName, setDiscountName] = React.useState('');
  const [used, setUsed] = React.useState(0);

  const [data, setData] = React.useState<any>({ ...defaultState });
  const { uuid: dUuid, status } = data;
  const isDraftArchive =
    status === EnumStatus.Draft || status === EnumStatus.Archived;
  const isActive =
    status === EnumStatus.Active ||
    status === EnumStatus.Scheduled ||
    status === EnumStatus.Expired;
  switchUuidHooks({ uuid: dUuid });
  const [loaded, setLoaded] = React.useState(false);
  //037fa3de-4e70-4b5f-8704-e4d6f52ec25e

  const handleOnResponse = (response: any) => {
    const { data, status, errorCode, errMsg, code } = response;
    if (data && status == 200) {
      return {
        valid: true,
        data: data.payload,
      };
    }
    if (errorCode == nameDuplicate && code == 400) {
      timeoutScroll('formName_name');
      form.setFields([{ name: 'name', errors: [errMsg] }]);
      return {
        valid: false,
      };
    }
    modal.error({
      title: getI18nFromGeneral('general.tools_server.requestError'),
      content: errMsg || 'System Error, Please Contact Admin',
      onCancel: () => {
        console.error(errMsg || 'System Error, Please Contact Admin');
      },
      onCancelText: 'Confirm',
    });

    return {
      valid: false,
    };
  };

  const handleOnAssData = (res) => {
    setData(res);
    let usePromotionCode = false;
    const {
      applyTo,
      attributes,
      codeCombineDisabled,
      autoCombineDisabled,
      codes,
      conditions,
      customerCondition,
      description,
      discountMethod,
      name,
      userLimitation,
      beginDate,
      beginTime,
      endDate,
      endTime,
      stackingPrivilegeEnabled,
    } = res;
    const used = get(res, 'userLimitation.usedCount');
    setUsed(used);
    setDiscountName(name);
    setActiveTime({ beginDate, beginTime, endDate, endTime });
    if (codes.length > 0) {
      usePromotionCode = true;
    }
    form.setFieldsValue({
      applyTo,
      attributes,
      codeCombineDisabled,
      autoCombineDisabled,
      codes,
      usePromotionCode,
      conditions: {
        ...defaultState.conditions,
        ...conditions,
      },
      customerCondition,
      description,
      discountMethod: {
        ...defaultState.discountMethod,
        ...discountMethod,
      },
      name,
      userLimitation,
      stackingPrivilegeEnabled,
    });
  };

  const getData = () => {
    if (canViewDetail) {
      setLoaded(false);
      getDiscountDetail(
        uuid,
        discountUuid,
        salesChannelMultiLanguageQueryParams,
      )
        .then((res) => {
          const { discountVO = {} } = res || {};
          const {
            conditionType,
            cumulative,
            flashSaleExcluded,
            maxTimes,
            maxTimesEnabled,
            products,
            toEntireOrder,
          } = discountVO.applyTo;
          const handleData = {
            ...discountVO,
            applyTo: {
              conditionType:
                conditionType !== null
                  ? conditionType
                  : defaultState.applyTo?.conditionType,
              cumulative: cumulative,
              flashSaleExcluded: flashSaleExcluded,
              maxTimes: maxTimes,
              maxTimesEnabled: maxTimesEnabled,
              products: products,
              toEntireOrder: toEntireOrder,
            },
          };
          setData(handleData);
          const { status } = discountVO;
          // const used = get(discountVO, 'userLimitation.usedCount');
          // setUsed(used);
          handleOnAssData(handleData);
          setLoaded(true);
          return status;
        })
        .then((status) => {
          if (status === EnumStatus.Draft || status === EnumStatus.Archived) {
            //  form.validateFields();
          }
        });
    }
  };

  React.useEffect(() => {
    if (isNew) {
      form.setFieldsValue(defaultState);
      setLoaded(true);
    } else {
      // getData();
    }
  }, []);
  React.useEffect(() => {
    if (!isNew) {
      getData();
    }
  }, [currentLanguage]);

  const handleOnError = (error) => {
    onFinishFailed(formName, error);
    return false;
  };

  const handleOnGetData = () => {
    const value = form.getFieldsValue();
    const submitData = {
      ...data,
      ...value,
      ...activeTime,
      codes: value.usePromotionCode ? value.codes || data.codes : [],
    };
    return submitData;
  };

  const handleOnSubmitDraft = () => {
    return form
      .validateFields(isPrimary ? ['name', 'codes'] : []) //
      .then((res) => {
        const submitData = handleOnGetData();
        return saveDirectDiscount(
          submitData,
          salesChannelMultiLanguageParams,
        ).then((res) => {
          const { valid, data } = handleOnResponse(res);

          if (valid) {
            setData(data);
            msg.success(getI18n('general.successfullyupdated'));
            setHasModified(false);
            return true;
          }
          return false;
        });
      })
      .catch(handleOnError);
  };
  // const handleOnSubmitArchive = () => {};
  const handleOnSubmitPublish = () => {
    const { valid: isTimeValid } = handleOnCheckTime(activeTime || {});
    if (isTimeValid) {
      return form
        .validateFields()
        .then((res) => {
          //  const value = form.getFieldsValue();
          const submitData = handleOnGetData();
          return saveDirectDiscount(
            submitData,
            salesChannelMultiLanguageParams,
          ).then((res) => {
            const { valid, data } = handleOnResponse(res);
            if (valid) {
              setData(data);
              msg.success(getI18n('general.successfullyupdated'));
              setHasModified(false);
              return true;
            }
            return false;
          });
        })
        .catch(handleOnError);
    } else {
      setActiveTimeError(true);
      timeoutScroll('DirectDiscountBasicInfo');
    }
  };

  const handleOnSubmit = () => {
    if (isDraftArchive) {
      return handleOnSubmitDraft();
    }
    if (isActive) {
      return handleOnSubmitPublish();
    }
  };

  const handleOnDuplicate = () => {
    const _duplicate = () => {
      const submitData = handleOnGetData();
      const { name } = submitData;
      submitData.name = `${name} Copy`;
      submitData.status = EnumStatus.Draft;
      submitData.uuid = null;
      submitData.userLimitation.usedCount = 0;
      submitData.codes = [];
      handleOnAssData(submitData);
      history.push({
        pathname: `/salesChannel/discounts/directDiscount/editor/${uuid}/${NEW}`,
        state: {
          skipNotice: true,
        },
      });
      msg.destroy();
      msg.success('Duplicated');
      timeoutScroll('tcContentTop');
    };
    //duplicate都是draft
    form.validateFields([]).then(() => {
      if (hasModified) {
        const promise = handleOnSubmit();
        if (promise) {
          promise.then((bol) => {
            //先提交
            if (bol) {
              _duplicate();
            }
          });
        }
      } else {
        _duplicate();
      }
    });
  };
  const handleOnToDraft = () => {
    form
      .validateFields(['name', 'codes'])
      .then(() => {
        if (hasModified) {
          modal.info({
            title: 'Save Changes',
            content: 'Please save changes before draft this discount.',
            //onCancel,
            onOkText: 'Save changes',
            onOk: () => handleOnSubmit(),
            // onCancelText,
          });
        } else {
          const submitData = handleOnGetData();
          const { uuid } = submitData;
          draftDiscount(uuid).then((res) => {
            msg.success(getI18n('general.successfullyupdated'));
            handleOnAssData(res);
          });
        }
      })
      .catch(handleOnError);
  };
  const handleOnToArchive = () => {
    modal.info({
      title: 'Archive Discount',
      content:
        'Archiving will deactivate this discount. You may find the archived discount in the archive section and restore it at any time.',
      //onCancel,
      onOkText: 'Archive',
      onOk: () => {
        return form
          .validateFields(['name', 'codes'])
          .then(() => {
            if (hasModified) {
              modal.info({
                title: 'Save Changes',
                content: 'Please save changes before archive this discount.',
                onCancel: () => {
                  return;
                },
                onOkText: 'Save changes',
                onOk: () => handleOnSubmit(),
                // onCancelText,
              });
            } else {
              const submitData = handleOnGetData();
              const { uuid } = submitData;
              archiveDiscount(uuid).then((res) => {
                msg.success(getI18n('general.successfullyupdated'));
                handleOnAssData(res);
              });
            }
          })
          .catch(handleOnError);
      },
      // onCancelText,
    });
  };
  const handleOnToPublish = () => {
    const { valid: isTimeValid, message } = handleOnCheckTime(activeTime || {});
    if (isTimeValid) {
      return form
        .validateFields()
        .then(() => {
          if (hasModified) {
            modal.info({
              title: 'Save Changes',
              content: 'Please save changes before publishing this discount.',
              //onCancel,
              onOkText: 'Save changes',
              onOk: () => handleOnSubmitPublish(),
              // onCancelText,
            });
          } else {
            const submitData = handleOnGetData();
            const { uuid } = submitData;
            activateDiscount(uuid).then((res) => {
              msg.success(getI18n('general.successfullyupdated'));
              handleOnAssData(res);
            });
          }
        })
        .catch((e) => {
          modal.info({
            title: 'Unable to Publish',
            content: 'Please fix all errors before publish',
            //onCancel,
            onOkText: 'OK',
            onOk: () => onFinishFailed(formName, e),
            // onCancelText,
          });
        });
    } else {
      modal.info({
        title: 'Unable to Publish',
        content: message || 'Please correct start and end time',
        //onCancel,
        onOkText: 'Ok',
        onOk: () => {
          setActiveTimeError(true);
          timeoutScroll('DirectDiscountBasicInfo');
        },
        // onCancelText,
      });
      // setActiveTimeError(true);
      // timeoutScroll('DirectDiscountBasicInfo');
    }
  };
  const handleActiveTimeChange = (value) => {
    setActiveTime(value);
    setHasModified(true);
  };

  const handleOnEligibleConditionChange = (changedValues) => {
    const conditionType = get(changedValues, 'customerCondition.conditionType');
    const isEveryone = ECondition.Everyone === conditionType;
    if (isEveryone) {
      form.setFieldsValue({
        userLimitation: {
          maxPerCustomerEnabled: false,
          maxPerCustomer: null,
        },
      });
    }
  };

  const onValuesChange = (changedValues) => {
    handleOnEligibleConditionChange(changedValues);

    setHasModified(true);
  };

  return canViewDetail ? (
    <React.Fragment>
      <_RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      {loaded ? (
        <Form name={formName} form={form} onValuesChange={onValuesChange}>
          {/* {isPrimary?} */}
          <Item
            shouldUpdate={(p, c) => {
              const pV = get(p, ['discountMethod', 'discountType']);
              const cV = get(c, ['discountMethod', 'discountType']);
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const type = getFieldValue(['discountMethod', 'discountType']);
              let ele = [
                { child: <Summary status={status} activeTime={activeTime} /> },
                {
                  child: (
                    <BasicInfo
                      isPrimary={isPrimary}
                      form={form}
                      activeTime={activeTime}
                      timezoneInGmt={scTimezoneUTC}
                      setActiveTime={(e) => {
                        handleActiveTimeChange(e);
                        setActiveTimeError(false);
                      }}
                      activeTimeError={activeTimeError}
                      setActiveTimeError={setActiveTimeError}
                      disableEdit={!canEdit}
                    />
                  ),
                },
                { child: <Method disableEdit={!canEdit} /> },
                {
                  child: (
                    <CustomerEligibleCondition
                      form={form}
                      disableEdit={!canEdit}
                      disabledEveryoneDependency={maxPerCustomerCheckbox}
                    />
                  ),
                },
                {
                  child: (
                    <OrderEligibleSection
                      form={form}
                      currency={currency}
                      disableEdit={!canEdit}
                    />
                  ),
                },
                { child: <Usage disableEdit={!canEdit} used={used} /> },
                { child: <Attributes disableEdit={!canEdit} /> },
              ];
              if (type === EMethod.Percentage) {
                ele = [
                  {
                    child: <Summary status={status} activeTime={activeTime} />,
                  },
                  {
                    child: (
                      <BasicInfo
                        isPrimary={isPrimary}
                        scTimezoneUTC={scTimezoneUTC}
                        setHasModified={setHasModified}
                        form={form}
                        activeTime={activeTime}
                        setActiveTime={handleActiveTimeChange}
                        activeTimeError={activeTimeError}
                        setActiveTimeError={setActiveTimeError}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Method disableEdit={!canEdit} /> },
                  {
                    child: (
                      <PercentageOff
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  {
                    child: (
                      <CustomerEligibleCondition
                        form={form}
                        disableEdit={!canEdit}
                        disabledEveryoneDependency={maxPerCustomerCheckbox}
                      />
                    ),
                  },
                  {
                    child: (
                      <OrderEligibleSection
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Usage disableEdit={!canEdit} used={used} /> },
                  { child: <Attributes disableEdit={!canEdit} /> },
                ];
              }
              if (type === EMethod.Reduction) {
                ele = [
                  {
                    child: <Summary status={status} activeTime={activeTime} />,
                  },
                  {
                    child: (
                      <BasicInfo
                        isPrimary={isPrimary}
                        form={form}
                        scTimezoneUTC={scTimezoneUTC}
                        activeTime={activeTime}
                        setActiveTime={handleActiveTimeChange}
                        activeTimeError={activeTimeError}
                        setActiveTimeError={setActiveTimeError}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Method disableEdit={!canEdit} /> },
                  {
                    child: (
                      <FixedReductionAmount
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  {
                    child: (
                      <CustomerEligibleCondition
                        form={form}
                        disableEdit={!canEdit}
                        disabledEveryoneDependency={maxPerCustomerCheckbox}
                      />
                    ),
                  },
                  {
                    child: (
                      <OrderEligibleSection
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Usage disableEdit={!canEdit} used={used} /> },
                  { child: <Attributes disableEdit={!canEdit} /> },
                ];
              }
              if (type === EMethod.Gift) {
                ele = [
                  {
                    child: <Summary status={status} activeTime={activeTime} />,
                  },
                  {
                    child: (
                      <BasicInfo
                        isPrimary={isPrimary}
                        form={form}
                        scTimezoneUTC={scTimezoneUTC}
                        activeTime={activeTime}
                        setActiveTime={handleActiveTimeChange}
                        activeTimeError={activeTimeError}
                        setActiveTimeError={setActiveTimeError}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Method disableEdit={!canEdit} /> },
                  {
                    child: (
                      <Buy1Get1Free
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  {
                    child: (
                      <CustomerEligibleCondition
                        form={form}
                        disableEdit={!canEdit}
                        disabledEveryoneDependency={maxPerCustomerCheckbox}
                      />
                    ),
                  },
                  {
                    child: (
                      <OrderEligibleSection
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Usage disableEdit={!canEdit} used={used} /> },
                  { child: <Attributes disableEdit={!canEdit} /> },
                ];
              }
              if (type === EMethod.Shipping) {
                ele = [
                  {
                    child: <Summary status={status} activeTime={activeTime} />,
                  },
                  {
                    child: (
                      <BasicInfo
                        isPrimary={isPrimary}
                        form={form}
                        scTimezoneUTC={scTimezoneUTC}
                        activeTime={activeTime}
                        setActiveTime={handleActiveTimeChange}
                        activeTimeError={activeTimeError}
                        setActiveTimeError={setActiveTimeError}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Method disableEdit={!canEdit} /> },
                  {
                    child: <DeliveryMethod disableEdit={!canEdit} />,
                  },
                  {
                    child: <Destination form={form} disableEdit={!canEdit} />,
                  },
                  {
                    child: (
                      <ShippingDiscountValue
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  {
                    child: (
                      <CustomerEligibleCondition
                        form={form}
                        disableEdit={!canEdit}
                        disabledEveryoneDependency={maxPerCustomerCheckbox}
                      />
                    ),
                  },
                  {
                    child: (
                      <OrderEligibleSection
                        form={form}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                  { child: <Usage disableEdit={!canEdit} used={used} /> },
                  { child: <Attributes disableEdit={!canEdit} /> },
                ];
              }
              return isPrimary ? (
                <Layout
                  topLeft={
                    <Left
                      name={discountName}
                      salesChannelName={get(salesChannel, 'name')}
                    />
                  }
                  topRight={
                    <Right
                      isPrimary={isPrimary}
                      status={status}
                      isNew={isNew}
                      onDraft={handleOnToDraft}
                      onRestore={handleOnToDraft}
                      onPublish={handleOnToPublish}
                      onArchive={handleOnToArchive}
                      onDuplicate={handleOnDuplicate}
                      onSubmit={handleOnSubmit}
                      hasModified={hasModified}
                      disableEdit={!canEdit}
                      disableDelete={!canDelete}
                    />
                  }
                  elements={ele}
                />
              ) : (
                <Layout
                  topLeft={
                    <Left
                      name={discountName}
                      salesChannelName={get(salesChannel, 'name')}
                    />
                  }
                  topRight={
                    <Right
                      isPrimary={isPrimary}
                      status={status}
                      isNew={isNew}
                      onDraft={handleOnToDraft}
                      onRestore={handleOnToDraft}
                      onPublish={handleOnToPublish}
                      onArchive={handleOnToArchive}
                      onDuplicate={handleOnDuplicate}
                      onSubmit={handleOnSubmit}
                      hasModified={hasModified}
                      disableEdit={!canEdit}
                      disableDelete={!canDelete}
                    />
                  }
                  elements={[
                    {
                      child: (
                        <BasicInfo
                          isPrimary={isPrimary}
                          form={form}
                          scTimezoneUTC={scTimezoneUTC}
                          activeTime={activeTime}
                          setActiveTime={handleActiveTimeChange}
                          activeTimeError={activeTimeError}
                          setActiveTimeError={setActiveTimeError}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                  ]}
                />
              );
            }}
          </Item>
        </Form>
      ) : (
        <Spin />
      )}
    </React.Fragment>
  ) : (
    <NoPermission />
  );
};
export default SalesChannelHOC(SelectHOC(DirectDiscount), {
  type: EnumMultiLanguageType.SalesChannelDiscountsDirectDiscount,
});

// const Test = (props) => {
//   const { value, onChange, id } = props;
//   const [data, setData] = React.useState(value || { test: { v1: '' }, v2: '' });

//   return (
//     <div id={id}>
//       <input
//         value={data.v1}
//         onChange={(e) => {
//           const v = e.target.value;
//           setData({ ...data, test: { v1: v } });
//           onChange({ ...data, test: { v1: v } });
//         }}
//       />
//       <input
//         value={data.v2}
//         onChange={(e) => {
//           const v = e.target.value;
//           setData({ ...data, v2: v });
//           onChange({ ...data, v2: v });
//         }}
//       />
//     </div>
//   );
// };
